/**
 * Content regions (openspec change `in-app-feedback`, design D4): every element that renders
 * tenant-provided strings carries `data-esi-content="<region>"`. A feedback screenshot replaces
 * each marked element with a neutral block of its size unless the user unmasks its region for
 * that send; a marked element inside an unmasked one stays masked unless its own region is
 * unmasked too. `page` marks each screen's whole content area, so anything a screen renders is
 * masked by default even where a finer marker is missing.
 */
export const CONTENT_ATTRIBUTE = "data-esi-content";

export const CONTENT_REGIONS = [
  "page",
  "messages",
  "composer",
  "conversations",
  "projects",
  "files",
  "documents",
  "wiki",
  "people",
  "tasks",
  "memory",
] as const;
export type ContentRegion = (typeof CONTENT_REGIONS)[number];

export function isContentRegion(value: string | null | undefined): value is ContentRegion {
  return (CONTENT_REGIONS as readonly (string | null | undefined)[]).includes(value);
}
